import { frontendURL } from '../../../../helper/URLHelper';

const generalSettingsBillingRedirects = {
  billing: 'general_settings_billing',
  'billing/plans': 'general_settings_billing_plans',
  'whatsapp-fees': 'general_settings_whatsapp_fees',
  'ai-billing': 'general_settings_ai_billing',
};

const settingsBillingRedirects = {
  '': 'general_settings_billing',
  plans: 'general_settings_billing_plans',
  'whatsapp-fees': 'general_settings_whatsapp_fees',
  'ai-billing': 'general_settings_ai_billing',
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/general/admin'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/general/security'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    ...Object.entries(generalSettingsBillingRedirects).map(
      ([legacyPath, routeName]) => ({
        path: frontendURL(`accounts/:accountId/settings/general/${legacyPath}`),
        redirect: to => ({
          name: routeName,
          params: { accountId: to.params.accountId },
        }),
      })
    ),
    ...Object.entries(settingsBillingRedirects).map(([subpath, routeName]) => ({
      path: frontendURL(
        `accounts/:accountId/settings/billing${subpath ? `/${subpath}` : ''}`
      ),
      redirect: to => ({
        name: routeName,
        params: { accountId: to.params.accountId },
      }),
    })),
  ],
};
